import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Container,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Paper,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { callPostApi } from "../API/ApiCallFunction";
import InfoPopover from "../CommanComponents/InfoPopover";
import GradientLoader from "../CommanComponents/GradientLoader";
import { toast } from "react-toastify";

export default function StoreLoyaltySetting() {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [minorderamountearn, setminorderamount] = useState("200");
  const [minorderamountapply, setminorderamountapply] = useState("100");
  const [lpvmonth, setlpvmonth] = useState("1");
  const [mrepercent, setmrepercent] = useState("1");
  const [mpearn, setmpearn] = useState("1");
  const [lvp, setlvp] = useState("1");
  const [adpnamtworth, setadpnamtworth] = useState("100");
  const [upiidtext, setupiidtext] = useState("");
  const [ptearn, setptearn] = useState("10");
  const [earnppercent, setearnppercent] = useState("1");
  const [welcomepoint, setwelcomepoint] = useState("");
  const [referrebons, setreferrebons] = useState("");
  const [eptype, seteptype] = useState("1");

  useEffect(() => {
    getloyaltydetails();
  }, []);

  const getloyaltydetails = async () => {
    setLoading(true);
    const storeid = user.store_info.store_id;
    const payload = {
      mod: "STORE_LOYALTY_DETAIL",
      data_arr: { store_id: storeid },
    };
    const apiResult = await callPostApi("store-detail", payload);
    if (apiResult.status === "200" && apiResult.data) {
      const item = apiResult.data.loyaltyDetail;
      setminorderamount(item.earn_cart_amount);
      setmrepercent(item.max_redeem_percentage);
      setlpvmonth(item.point_life);
      setupiidtext(item.digital_upi_id);
      setmpearn(item.max_point_earn);
      seteptype(""+item.earn_point_type);
      setadpnamtworth(item.incremental_cart_amount);
      setwelcomepoint(item.welcome_point);
      setreferrebons(item.referral_bonus_point);
      setptearn(item.earn_point);
      setearnppercent(item.earn_point_percent);
      setminorderamountapply(item.redeem_cart_amount);
    }
    setLoading(false);
  };

  const handleformsave = () => {
    apisaveform();
  };

  const apisaveform = async () => {
    setLoading(true);
    const storeid = user.store_info.store_id;
    const payload = {
      mod: "UPDATE_LOYALTY",
      data_arr: {
        store_id: storeid,
        earn_cart_amount: minorderamountearn,
        redeem_cart_amount: minorderamountapply,
        earn_point_type: eptype,
        earn_point_percent: earnppercent,
        earn_point: ptearn,
        incremtCartAmount: adpnamtworth,
        max_point_earn: mpearn,
        point_value: "1",
        point_life: lpvmonth,
        max_redeem_percentage: mrepercent,
        loyalty_enable: "Yes",
        digital_upi_id: upiidtext,
        welcome_point: welcomepoint,
        referral_bonus_point: referrebons,
      },
    };

    const apiResult = await callPostApi("store-update", payload);
    if (apiResult.status === "200" && apiResult.data) {
      toast.success("Updated Successfully");
      navigate("/dashboard");
    }
    setLoading(false);
  };

  return (
    <Container sx={{ my: 6 }}>
      {loading && <GradientLoader text="Saving Loyalty Settings..." />}

    <Box sx={{ display: 'flex', justifyContent: 'start', mb: 2 }}>
          <Button  variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}  onClick={() => navigate(-1)} >
            Back </Button>
         </Box>

      <Typography
        variant="h5"
        sx={{
          mb: 3,
          fontWeight: 600,
          color: "#0a4811",
        }}
      >
        Loyalty Program Settings
      </Typography>
 



      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
      <Grid  spacing={3} direction={'column'} container>
      {/* Row 1 */}
      <Grid item xs={12}  >
        <TextField
          fullWidth
          label="What is minimum Order value to earn first loyalty point?"
          type="number"
          value={minorderamountearn}
          onChange={(e) => setminorderamount(e.target.value)}
        />
        <InfoPopover title="What is minimum Order value to earn first loyalty point?" description="वह न्यूनतम ऑर्डर राशि क्या है जो आप अपने ग्राहक को एक लॉयल्टी पॉइंट अर्जित करने के लिए चाहते हैं?" />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="What is minimum Order value to apply loyalty point?"
          type="number"
          value={minorderamountapply}
          onChange={(e) => setminorderamountapply(e.target.value)}
        />
   <InfoPopover title="What is minimum Order value to apply loyalty point?" description="लॉयल्टी पॉइंट लागू करने के लिए न्यूनतम ऑर्डर मूल्य क्या है?" />      </Grid>

      {/* Row 2 */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="What is the validity of 1 loyalty point?"
          type="number"
          value={lpvmonth}
          onChange={(e) => setlpvmonth(e.target.value)}
        />

<InfoPopover title="What is the validity of 1 loyalty point?" description="एक लॉयल्टी पॉइंट की वैधता क्या होगी?" />      </Grid>



      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Maximum Points Earnable"
          type="number"
          value={mpearn}
          onChange={(e) => setmpearn(e.target.value)}
        />
<InfoPopover title="What is the Maximum Points Earnable?" description="" />      </Grid>


      {/* Row 3 */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="What is the maximum redeem percentage for spending loyalty points?"
          type="number"
          value={mrepercent}
          onChange={(e) => setmrepercent(e.target.value)}
        />
<InfoPopover title="What is the maximum redeem percentage for spending loyalty points?" description="लॉयल्टी पॉइंट रिडीम करने पर कटौती करने के लिए अधिकतम राशि क्या होगी?" />      </Grid>


      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <FormLabel sx={{ fontWeight: 600, color: "#000" }}>
            Earn Point Type
          </FormLabel>
          <RadioGroup
            row
            value={eptype}
            onClick={(e) => seteptype(e.target.value)}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Incremental"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Percentage"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      {/* Conditional Row (Row 4) */}
      {eptype === "1" ? (
        <>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Additional Points per Amount Worth"
              type="number"
              value={adpnamtworth}
              onChange={(e) => setadpnamtworth(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Points to Earn"
              type="number"
              value={ptearn}
              onChange={(e) => setptearn(e.target.value)}
            />
          </Grid>
        </>
      ) : (
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Earn Point Percentage"
            type="number"
            value={earnppercent}
            onChange={(e) => setearnppercent(e.target.value)}
          />
        </Grid>
      )}

      {/* Row 5 */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="How Many Bonus Welcome Points Do you want to Issue to Customers on Joining Loyalty?"
          type="number"
          value={welcomepoint}
          onChange={(e) => setwelcomepoint(e.target.value)}
        />
        

<InfoPopover title="How Many Bonus Welcome Points Do you want to Issue to Customers on Joining Loyalty?
" description="लॉयल्टी में शामिल होने पर आप ग्राहकों को कितने बोनस वेलकम पॉइंट जारी करना चाहते हैं?" /> 
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="How many Referral Bonuses do you want to be Issued to referrals on the first purchase?"
          type="number"
          value={referrebons}
          onChange={(e) => setreferrebons(e.target.value)}
        />


<InfoPopover title="How many Referral Bonuses do you want to be Issued to referrals on the first purchase?" description="आप पहली खरीद पर रेफ़रल को कितने रेफ़रल बोनस जारी करना चाहते हैं?" /> 
      </Grid>

    

      {/* Row 6 */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Digital UPI ID (for Payment)"
          value={upiidtext}
          onChange={(e) => setupiidtext(e.target.value)}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography
          variant="subtitle1"
          sx={{ mt: 3, color: "#1976d2", fontWeight: "bold" }}
        >
          Loyalty Point Value: {lvp}
        </Typography>
      </Grid>
    </Grid>

        <Divider sx={{ my: 6 }} />

        <Box sx={{ textAlign: "center" }}>
          <Button
            variant="contained"
            onClick={handleformsave}
            sx={{
              backgroundColor: "#0a4811",
              textTransform: "none",
              fontWeight: "bold",
              px: 5,
              py: 1.2,
              "&:hover": { backgroundColor: "#0c6015" },
            }}
          >
            Save Settings
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
